import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { EASE } from "@/lib/scroll";
import { Reveal, Eyebrow } from "../Reveal";
import { PriceItem } from "./PriceItem";

const Featured = ({ f, onBook }) => (
  <Reveal className="mb-8 rounded-[28px] border border-gold/40 bg-gradient-to-br from-paper to-champagne p-6 sm:p-8">
    <div data-testid="price-featured" className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-[0.26em] text-gold-deep">Empfehlung zum Einstieg</p>
        <h3 className="mt-2 font-serif text-3xl text-ink">{f.title}</h3>
        <p className="mt-3 max-w-md text-[15px] leading-relaxed text-ink-soft">{f.desc}</p>
      </div>
      <div className="flex shrink-0 flex-row items-center justify-between gap-4 sm:flex-col sm:items-end">
        <p className="whitespace-nowrap font-serif text-4xl text-gold-deep">
          <span className="mr-1 text-xl italic text-ink-soft">{f.prefix}</span>
          {f.price}
        </p>
        <button onClick={() => onBook(f.title)} data-testid="price-featured-book-btn" className="btn-gold whitespace-nowrap rounded-full px-5 py-2.5 text-[11px] font-semibold uppercase tracking-[0.16em]">
          Termin vereinbaren
        </button>
      </div>
    </div>
  </Reveal>
);

export const PriceCategory = ({ g, onBook }) => (
  <section id={g.id} data-testid={`price-category-${g.id}`} className="scroll-mt-32 border-t border-gold/25 py-16 lg:py-24">
    <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
      <div className="lg:sticky lg:top-36 lg:self-start">
        <Reveal>
          <Eyebrow index={g.index}>{g.subtitle}</Eyebrow>
          <h2 className="mt-5 font-serif text-4xl leading-[1.05] text-ink sm:text-5xl">{g.title}</h2>
          <p className="mt-4 max-w-sm text-[15px] leading-relaxed text-ink-soft">{g.intro}</p>
        </Reveal>
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="relative mt-8 aspect-[16/10] overflow-hidden rounded-tl-[64px] rounded-br-[64px] bg-champagne lg:aspect-[4/3]"
        >
          <motion.img
            variants={{ hidden: { scale: 1.18 }, show: { scale: 1 } }}
            transition={{ duration: 1.6, ease: EASE }}
            src={g.img}
            style={{ objectPosition: g.pos || "50% 50%" }}
            alt={g.alt}
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </motion.div>
        <p className="mt-5 flex items-start gap-2 text-sm leading-relaxed text-ink" data-testid={`price-consult-${g.id}`}>
          <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" strokeWidth={1.6} /> {g.consult}
        </p>
      </div>
      <div>
        {g.featured && <Featured f={g.featured} onBook={onBook} />}
        {g.items.map((item, i) => (
          <PriceItem key={item.title} item={item} onBook={onBook} delay={Math.min(i, 3) * 0.05} />
        ))}
      </div>
    </div>
  </section>
);
